<template>
    <div :style="selectedTags.length > 2 && 'overflow: hidden;'" v-if="!$vuetify.display.mobile">
        <component
            :is="component"
            :key="props.variant === 'filled' ? 'v-combobox-filled' : 'v-comboboxx'"
            v-model="selectedTags"
            :hide-no-data="!search"
            :items="props.items"
            :search-input="search"
            :label="props.label"
            :item-title="props.itemTitle"
            hide-selected
            multiple
            hide-details
            :single-line="selectedTags.length > 2"
            :list-props="{ maxWidth: comboListMaxWidth }"
        >
            <template v-slot:selection="{ item, selected, index }">
                <v-chip
                    v-if="item === Object(item) && index < 3"
                    :color="`${item.raw.color}`"
                    :model-value="selected"
                    :variant="item.raw.type === 'SubAccountableAccount' ? 'outlined' : 'flat'"
                    size="small"
                    density="compact"
                    label
                >
                    <span class="pr-2 text-secondary">{{ item.title }}</span>
                    <v-icon icon="$close" @click="remove(item.raw)" class="text-secondary" />
                </v-chip>
                <span class="text-subtitle-2" v-else-if="index === selectedTags.length - 3">
                    + {{ selectedTags.length - 3 }} autre(s)</span
                >
            </template>
            <template #item="{ item, props }">
                <v-list-item
                    v-bind="props"
                    :style="{
                        minHeight: '30px',
                        pointerEvents: item.raw.header ? 'none' : 'auto',
                    }"
                >
                    <template #title />
                    <span v-if="item.raw.header" class="text-subtitle-2 text-medium-emphasis">{{
                        item.raw.header
                    }}</span>
                    <v-chip
                        v-else
                        :color="`${item.raw.color}`"
                        :variant="item.raw.type === 'SubAccountableAccount' ? 'outlined' : 'flat'"
                        size="small"
                        label
                    >
                        <span class="text-secondary">
                            {{ item.title }} {{ item.raw.count ? " (" + item.raw.count + ")" : "" }}
                        </span>
                    </v-chip>
                </v-list-item>
            </template>
        </component>
    </div>
</template>

<script lang="ts" setup>
import { VCombobox } from "vuetify/lib/components/index.mjs";
import { computed, ref } from "vue";
import { useDefaults } from "vuetify";

interface IProps {
    items: any[];
    label: string;
    itemTitle?: string | ((item: any) => string);
    variant?: "clear" | "filled";
}

const props_ = defineProps<IProps>();
const props = useDefaults(props_, "OssTagsSelector");

const comboListMaxWidth = "300px";

const modelValue = defineModel<any>();

const search = ref(null);

// Dynamic component tag
const component = computed(() => {
    return props.variant === "filled" ? "v-combobox-filled" : VCombobox;
});

const selectedTags = computed({
    get: () => modelValue.value,
    set: (tags) => {
        modelValue.value = tags;
    },
});

const remove = (item) => {
    selectedTags.value = selectedTags.value.filter((x) => x.id !== item.id);
};
</script>
<style lang="scss"></style>
